import { useContext, useEffect, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Tooltip,
} from "@material-ui/core";

import { ExpandMore, Add, EditOutlined } from "@material-ui/icons";

import {
  BallContainer,
  HeaderAccordion,
  IconButtonStyled,
  TableContent,
  WarningLabel,
} from "../styles/Produto";
import RedBall from "../../../../assets/imgs/bolinha-vermelha.png";
import GreenBall from "../../../../assets/imgs/bolinha-verde.png";
import TableDefault from "../../../../components/grid/TableDefault";
import { ProdutoContext } from "../contexts/ProdutoContext";
import useProdutoController from "../controllers/ProdutoController";
import ModalProdutoLocalEstoque from "./ModalProdutoLocalEstoque";
import Chip from "../../../../components/basics/Chip";
import SpeedDialErp from "../../../../components/speeddial/SpeedDialErp";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import MaskService from "../../../../utils/mask/maskService";

export default function AccordionProdutoLocalEstoque() {
  const { queryParams } = useContext(QueryParamsContext);
  const {
    stockLocations,
    expanded,
    errors,
    listStockLocations,
    mainProductId,
  } = useContext(ProdutoContext);

  const {
    handleChangeOpenAcordion,
    // handleRemoveItemTable,
    handleEditItemTable,
  } = useProdutoController();

  const [open, setOpen] = useState(false);
  const [rowEdit, setRowEdit] = useState(null);
  const [dataTable, setDataTable] = useState([]);
  const [disabledAddStock, setDisabledAddStock] = useState(false);
  const [ableToRegister, setAbleToRegister] = useState([]);

  const useUniqueStockPrice = queryParams.paramprecoestoqueunico === "SIM";
  const useBarCodeOnStock = queryParams.codigobarraslocalestoque === "SIM";
  const useVarejoAtacado = queryParams.paramutilizavarejoatacado === "SIM";

  const getFixedParseFloat = (value, fractionDigits) => {
    return (!isNaN(parseFloat(value)) ? parseFloat(value) : 0).toFixed(
      fractionDigits
    );
  };

  const columns = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (item) => {
        const actions = [
          // {
          //   name: "Deletar",
          //   icon: <DeleteOutlineOutlinedIcon />,
          //   action: () =>
          //     handleRemoveItemTable(
          //       setDataTable,
          //       setStockLocations,
          //       stockLocations,
          //       item.index
          //     ),
          // },
          {
            name: "Editar",
            icon: <EditOutlined />,
            action: () =>
              handleEditItemTable(
                setOpen,
                setRowEdit,
                item,
                item.index,
                mainProductId
              ),
          },
        ];

        return <SpeedDialErp actions={actions} />;
      },
      show: true,
    },
    {
      id: "descricao",
      label: "Local de Estoque",
      show: true,
    },
    {
      id: "localizacao",
      label: "Localização",
      format: (item) => {
        const localizacao = [];
        if (item.salao) localizacao.push("Sal.: " + item.salao);
        if (item.corredor) localizacao.push("Corr.: " + item.corredor);
        if (item.prateleira) localizacao.push("Prat.: " + item.prateleira);
        if (item.box) localizacao.push("Box: " + item.box);

        return localizacao.join(`, `);
      },
      show: true,
    },
    {
      id: "codigobarras",
      label: "Cód. Barras",
      show: useBarCodeOnStock,
    },
    {
      id: "custobruto",
      label: "Custo Bruto",
      show: !useUniqueStockPrice,
      format: (item) =>
        MaskService.toMask(
          "decimal",
          getFixedParseFloat(item?.custobruto, 5),
          5
        ),
    },
    {
      id: "precoultimacompra",
      label: "Custo Real",
      show: !useUniqueStockPrice,
      format: (item) =>
        MaskService.toMask(
          "decimal",
          getFixedParseFloat(item?.precoultimacompra, 5),
          5
        ),
    },
    {
      id: "precovenda",
      label: "Preço Venda",
      show: !useUniqueStockPrice,
      format: (item) =>
        MaskService.toMask(
          "decimal",
          getFixedParseFloat(item?.precovenda, 2),
          2
        ),
    },
    {
      id: "precovarejo",
      label: "Preço Varejo",
      show: useVarejoAtacado,
      format: (item) =>
        MaskService.toMask(
          "decimal",
          getFixedParseFloat(item?.precovenda, 2),
          2
        ),
    },
    {
      id: "precoatacado",
      label: "Preço Atacado",
      show: useVarejoAtacado,
      format: (item) =>
        MaskService.toMask(
          "decimal",
          getFixedParseFloat(item?.precoatacado, 2),
          2
        ),
    },
    {
      id: "qtdeminima",
      label: "Estoque Mín.",
      show: true,
      format: (item) => getFixedParseFloat(item?.qtdeminima, 2),
    },
    {
      id: "qtdemaxima",
      label: "Estoque Máx.",
      show: true,
      format: (item) => getFixedParseFloat(item?.qtdemaxima, 2),
    },
    {
      id: "active",
      label: "Ativo",
      show: true,
      format: (item) =>
        item.inativo === "N" ? (
          <BallContainer>
            <img src={GreenBall} alt="green-ball" />
          </BallContainer>
        ) : (
          <BallContainer>
            <img src={RedBall} alt="red-ball" />
          </BallContainer>
        ),
      disablePadding: true,
    },
  ];

  useEffect(() => {
    const existentIds = dataTable.map((tableItem) => tableItem.idlocalestoque);
    const allowedToRegister = [];
    listStockLocations.forEach((listItem) => {
      if (!existentIds.includes(listItem.id)) {
        allowedToRegister.push(listItem.id);
      }
    });

    setAbleToRegister(allowedToRegister);
    setDisabledAddStock(false);
    if (allowedToRegister.length === 0) setDisabledAddStock(true);
  }, [listStockLocations, dataTable]);

  // adiciona manualmente o index atual do item para editá-lo ou removê-lo
  useEffect(() => {
    const newList = stockLocations.map((item, index) => ({
      ...item,
      index,
    }));

    setDataTable(newList);
  }, [stockLocations]);

  return (
    <>
      {open && (
        <ModalProdutoLocalEstoque
          open={open}
          setOpen={setOpen}
          setRowEdit={setRowEdit}
          rowEdit={rowEdit}
          ableToRegister={ableToRegister}
          mainProductId={mainProductId || null}
        />
      )}
      <Grid item xs={12}>
        <Accordion
          expanded={expanded.stockLocation || false}
          onChange={() => handleChangeOpenAcordion("stockLocation")}
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs>
                  <Chip
                    label="LOCAIS DE ESTOQUE"
                    error={
                      (!expanded.stockLocation &&
                        errors.accordionStockLocations) ||
                      (!expanded.stockLocation &&
                        errors.accordionStockLocationsLength)
                    }
                  />
                </Grid>

                <Grid item flex={1}>
                  <Tooltip
                    title={
                      disabledAddStock
                        ? `Todos os locais de estoque já utilizados`
                        : `Adicionar Local de Estoque`
                    }
                  >
                    <span onClick={() => setOpen(!disabledAddStock)}>
                      <IconButtonStyled disabled={disabledAddStock}>
                        <Add />
                      </IconButtonStyled>
                    </span>
                  </Tooltip>
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TableContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TableDefault
                        columns={columns.filter((e) => e.show)}
                        values={dataTable}
                        tableTitle={
                          errors.accordionStockLocationsLength ? (
                            <WarningLabel>
                              Informe ao menos um local de estoque
                            </WarningLabel>
                          ) : (
                            ""
                          )
                        }
                      />
                    </Grid>
                  </Grid>
                </TableContent>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
}
